export default __webpack_public_path__ + "static/media/gafri-shop-sargsyan.2c92a189.jpg";